import { Dialog } from '@elementary/common-ui/components';
import type { IncidentV2TicketRow } from '../types';

type Props = {
  ticket: IncidentV2TicketRow;
  isUnlinking: boolean;
  onClose: () => void;
  onConfirm: (serviceTicketId: string) => Promise<unknown>;
};

const UnlinkIncidentV2TicketDialog = ({
  ticket,
  isUnlinking,
  onClose,
  onConfirm,
}: Props) => (
  <Dialog
    open
    title="Unlink ticket"
    confirmText="Unlink"
    variant="error"
    isLoading={isUnlinking}
    closeOnBackdropClick={!isUnlinking}
    onClose={onClose}
    onConfirmButtonClick={() => {
      onConfirm(ticket.service_ticket_id)
        .then(() => onClose())
        .catch(() => {});
    }}
    message="Are you sure you want to unlink this ticket from the incident?"
  />
);

export default UnlinkIncidentV2TicketDialog;
